// @flow
/** @jsx jsx */

import React from 'react';
import { jsx } from '@emotion/core'
import FullSizeCenteredContent from './FullSizeCenteredContent'
import Loader from './Loading'
import { useMobileMediaQuery } from '../config/mediaQuery';

type Props = {
  isLoading: boolean,
  isRefetching: boolean,
  hasAllColumnsHidden: boolean,
  hasDataToDisplay: boolean,
  collection: any,
  children: ({ show: boolean }) => React.Node,
  noContentMsg?: string,
}

const ContentChecker = (props: Props) => {
    const {
      isLoading,
      isRefetching,
      hasAllColumnsHidden,
      hasDataToDisplay,
      collection,
    } = props;

    const isMobile = useMobileMediaQuery();

    if (isLoading && (!isRefetching || !hasDataToDisplay)) {
      return (
        <FullSizeCenteredContent>
          <Loader
            blocking={isRefetching && hasDataToDisplay}
            loading={isLoading}
          />
        </FullSizeCenteredContent>
      )
    }
    const noContentToDisplay = hasAllColumnsHidden || !hasDataToDisplay
    
    if (collection) {
      return (
        <React.Fragment>
          {collection && (
            <div
              css={{
                display: noContentToDisplay && !isMobile ? 'none' : 'block',
              }}
            >
              {props.children({ show: true })}
            </div>
          )}
        </React.Fragment>
      )
    }
    return null
}
export default ContentChecker;